import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatImage } from '@ifeng-fe/three_terminal/es/base/publicMethod/formatImage';
import styles from './index.css';
import { useFixedTitle } from '../hooks';

const cx = classNames.bind(styles);

const Live = ({ content }) => {
    const { liveInfo, showFixedTitle } = content;
    const [iframeDistance, setIframeDistance] = useState(0);
    const IframeVideoRef = useRef(null);
    const IframeRef = useRef(null);
    const [isCloseFix, setIsCloseFix] = useState(false);
    const {
        title,
        poster = 'https://x0.ifengimg.com/fe/custom/2022_08_04/58aef25e928669a97f1481116c466042.png',
    } = liveInfo;

    const [showFixedPlayer, setShowFixedPlayer] = useState(true);

    const videoRef = useRef();

    useEffect(
        () => {
            if (showFixedTitle) {
                setShowFixedPlayer(true);
            }
        },
        [showFixedTitle],
    );

    const [playStart, setPlayStart] = useState(false);
    const [playing, setPlaying] = useState(false);

    const playerFixed = showFixedPlayer && showFixedTitle && playing;

    useEffect(
        () => {
            if (videoRef.current) {
                if (!playing) {
                    if (playStart) {
                        videoRef.current.pause();
                    }
                } else {
                    videoRef.current.play();

                    if (!playStart) {
                        setPlayStart(true);
                    }
                }
            }
        },
        [playing],
    );

    const timerPlayerClickRef = useRef(0);
    const [showAction, setShowAction] = useState(false);

    const handlePlayerClick = () => {
        clearTimeout(timerPlayerClickRef.current);

        if (!showAction) {
            setShowAction(true);
        }

        timerPlayerClickRef.current = setTimeout(() => {
            setShowAction(false);
        }, 2000);
    };

    const [playerMuted, setPlayerMuted] = useState(false);

    const handleFixedCloseClick = () => {
        setShowFixedPlayer(false);
        setIsCloseFix(true);

        if (playing) {
            setPlaying(false);
        }
    };

    const hlsRef = useRef(new window.Hls());

    const iframeVideoAutoPlay = () => {
        IframeRef.current.contentWindow.postMessage({ type: 'autoPlay' }, '*');
    };

    const newAppPlay = () => {
        const creatFun = callback => {
            const funName = `__grounds_${Number(Math.floor(Math.random() * 10000000000)).toString(36)}`;

            window[funName] = msg => {
                callback(msg);
            };

            return funName;
        };
        const __Native = {
            intercall: (appCommand, callback) => {
                const funName = creatFun(callback);

                if (window.grounds) {
                    window.grounds[appCommand](funName);
                }
            },
        };

        __Native.intercall('deviceInfo', () => {
            iframeVideoAutoPlay();
        });
    };

    const autoplayHandler = () => {
        let isWxReady = false;
        let playerReady = false;
        const isWeixin = navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1;

        if (isWeixin) {
            // 微信
            if (typeof WeixinJSBridge == 'undefined') {
                document.addEventListener(
                    'WeixinJSBridgeReady',
                    () => {
                        isWxReady = true;
                        if (playerReady) {
                            iframeVideoAutoPlay();
                        }
                    },
                    false,
                );
            } else {
                isWxReady = true;
                if (playerReady) {
                    iframeVideoAutoPlay();
                }
            }
        }
        window.addEventListener('message', e => {
            // console.log(e.data, 'iframeData');
            if (e.data.type === 'init') {
                // 如果是自动播放需要自动播放
                playerReady = true;
                if (isWeixin) {
                    if (isWxReady) {
                        iframeVideoAutoPlay();
                    }
                } else if (window.grounds) {
                    newAppPlay();
                }
            }
        });
    };

    // 数字过万处理,超过一万显示为x.x万，不足一万显示原数字,小数点后一位不使用toFixed进行四舍五入
    const formatPeopleNum = num => {
        if (num >= 10000) {
            const decimal = Math.floor(num / 1000) / 10;

            return `${decimal.toString()}万`;
        } else {
            return num.toString();
        }
    };

    useLayoutEffect(() => {
        autoplayHandler();
    }, []);

    useEffect(() => {
        const IframeVideoTop = IframeVideoRef.current.getBoundingClientRect().top;
        const IframeVideoHeight = IframeVideoRef.current.getBoundingClientRect().height;

        setIframeDistance(IframeVideoTop + IframeVideoHeight);
    }, []);

    let showFixed = useFixedTitle(iframeDistance);

    if (isCloseFix) {
        showFixed = false;
    }

    useEffect(
        () => {
            if (videoRef.current) {
                const { liveUrl } = liveInfo;

                if (videoRef.current.canPlayType('application/vnd.apple.mpegurl')) {
                    videoRef.current.src = liveUrl;
                } else if (window.Hls.isSupported()) {
                    hlsRef.current.loadSource(liveUrl);
                    hlsRef.current.attachMedia(videoRef.current);
                }
            }
        },
        [liveInfo],
    );

    const handlePlay = () => {
        if (!playing) {
            setPlaying(true);
        }
    };

    const handlePause = () => {
        if (playing) {
            setPlaying(false);
        }
    };

    return (
        <div className={styles.wrap}>
            <div className={styles.content} ref={IframeVideoRef}>
                <div className={cx('player', { playerFixed: playerFixed || showFixed })} onClick={handlePlayerClick}>
                    {!liveInfo?.iframeUrl ? <video
                        ref={videoRef}
                        poster={poster}
                        muted={playerMuted}
                        x5-playsinline="x5-playsinline"
                        playsInline="playsInline"
                        webkit-playsinline="webkit-playsinline"
                        onPlay={handlePlay}
                        onPause={handlePause}
                    /> :
                        <div className={styles.iframeBox}>
                            <iframe
                                ref={IframeRef}
                                scrolling="no"
                                frameBorder="0"
                                className={styles.iframe}
                                src={liveInfo?.iframeUrl}
                            />
                        </div>}
                    {(playerFixed || showFixed) ? (
                        <div className={styles.playerFixedClose} onClick={handleFixedCloseClick} />
                    ) : (!liveInfo?.iframeUrl && <>
                            {playStart ? (
                                <div className={cx('action', { actionShow: showAction })}>
                                    <div
                                        className={cx('playBtn', playing ? 'playBtnPause' : 'playBtnPlay')}
                                        onClick={() => {
                                            setPlaying(prev => !prev);
                                        }}
                                    />
                                    <div className={styles.controls}>
                                        <div
                                            className={cx('volumeBtn', { volumeBtnMuted: playerMuted })}
                                            onClick={() => {
                                                setPlayerMuted(prev => !prev);
                                            }}
                                        />
                                        <div
                                            className={styles.fullScreenBtn}
                                            onClick={() => {
                                                if (videoRef.current) {
                                                    if (videoRef.current.requestFullscreen) {
                                                        videoRef.current.requestFullscreen();
                                                    } else if (videoRef.current.mozRequestFullScreen) {
                                                        videoRef.current.mozRequestFullScreen();
                                                    } else if (videoRef.current.webkitRequestFullscreen) {
                                                        videoRef.current.webkitRequestFullscreen();
                                                    } else if (videoRef.current.msRequestFullscreen) {
                                                        videoRef.current.msRequestFullscreen();
                                                    } else if (videoRef.current.webkitEnterFullscreen) {
                                                        videoRef.current.webkitEnterFullscreen();
                                                    } else {
                                                        console.error('全屏失败');
                                                    }
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <div className={styles.poster}>
                                        <img src={formatImage(poster, 1000, 562)} alt="" />
                                    </div>
                                    <div
                                        className={cx('playBtn', 'playBtnPlay')}
                                        onClick={() => {
                                            setPlaying(true);
                                        }}
                                    />
                                </>
                            )}
                        </>
                    )}
                </div>
            </div>
            {title ? <div className={styles.title}>{title}</div> : null}
        </div>
    );
};

Live.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Live);
